
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 1L1.312 5.791c-.377.132-.424.669-.076.87L4.454 8.52M15 1l-3.045 10.871a.453.453 0 01-.672.279l-3.266-1.996M15 1l-6.983 9.154M15 1L4.454 8.52m0 0l1.177 3.786c.09.291.471.359.656.116l1.73-2.268","stroke":"#fff","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    